module.exports = __webpack_public_path__ + "static/img/D004.0875e87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/D004.jpg
// module id = B/ol
// module chunks = 1